/* ======================================================
   Accessibility System Configuration
   WCAG 2.1 AA+ | Human-Centered Design
   ====================================================== */

export type FontSizeConfig = {
  min: number;
  max: number;
  step: number;
  default: number;
};

export type FeatureConfig = {
  default: boolean;
  userToggle: boolean;
  wcagLevel?: "A" | "AA" | "AAA";
  description?: string;
};

export type AccessibilityConfig = {
  fontSize: FontSizeConfig;

  contrast: FeatureConfig;
  reduceMotion: FeatureConfig;
  highlightLinks: FeatureConfig;
  highlightHeadings: FeatureConfig;
  readableFont: FeatureConfig;

  /* Preset system (future ready) */
  presets: {
    reading: string[];
    vision: string[];
    attention: string[];
  };
};

/* ======================================================
     CONFIG
  ====================================================== */

export const accessibilityConfig: AccessibilityConfig = {
  /* ---------------- FONT ---------------- */
  fontSize: {
    min: 100, // 80%
    max: 180, // 180%
    step: 10, // 10% increments
    default: 100, // normal size
  },

  /* ---------------- FEATURES ---------------- */

  contrast: {
    default: false,
    userToggle: true,
    wcagLevel: "AA",
    description: "Enhanced visual contrast for readability",
  },

  reduceMotion: {
    default: false,
    userToggle: true,
    wcagLevel: "AA",
    description: "Reduces animations and transitions",
  },

  highlightLinks: {
    default: false,
    userToggle: true,
    wcagLevel: "AA",
    description: "Highlights interactive links",
  },

  highlightHeadings: {
    default: false,
    userToggle: true,
    wcagLevel: "AA",
    description: "Highlights headings for structure scanning",
  },

  readableFont: {
    default: false,
    userToggle: true,
    wcagLevel: "AA",
    description: "Forces high-legibility font",
  },

  /* ---------------- PRESETS ---------------- */
  presets: {
    reading: ["readableFont", "reduceMotion", "fontSize"],
    vision: ["contrast", "highlightLinks", "highlightHeadings", "fontSize"],
    attention: ["reduceMotion", "highlightHeadings"],
  },
};
